import { render, staticRenderFns } from "./FooterRedirect.vue?vue&type=template&id=05394c1a"
import script from "./FooterRedirect.vue?vue&type=script&lang=js"
export * from "./FooterRedirect.vue?vue&type=script&lang=js"
import style0 from "./FooterRedirect.vue?vue&type=style&index=0&id=05394c1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports